export { default } from 'features/account/routes/account-info-route';
